import { fitCanvasToDisplaySize } from './utils.js';

export class Engine {
  constructor(canvas, updateFn, drawFn) {
    this.canvas = canvas;
    this.ctx = canvas.getContext('2d');
    this.updateFn = updateFn;
    this.drawFn = drawFn;

    this.accumulator = 0;
    this.last = performance.now();
    this.running = false;

    this.fixedDt = 1/120;
    this.maxFrame = 1/10;

    window.addEventListener('resize', ()=> fitCanvasToDisplaySize(this.canvas), { passive: true });
    // Handle iOS/Android URL bar show/hide and virtual keyboard changes
    if (window.visualViewport) {
      const fit = ()=> fitCanvasToDisplaySize(this.canvas);
      window.visualViewport.addEventListener('resize', fit, { passive: true });
      window.visualViewport.addEventListener('scroll', fit, { passive: true });
    }
    fitCanvasToDisplaySize(this.canvas);
  }

  start() {
    if (this.running) return; // idempotent
    this.running = true;
    this.last = performance.now();
    const loop = (t) => {
      if (!this.running) return;
      const now = t || performance.now();
      let frame = Math.min((now - this.last) / 1000, this.maxFrame);
      this.last = now;

      this.accumulator += frame;
      while (this.accumulator >= this.fixedDt) {
        this.updateFn(this.fixedDt);
        this.accumulator -= this.fixedDt;
      }

      this.drawFn(this.ctx);
      requestAnimationFrame(loop);
    };
    requestAnimationFrame(loop);
  }

  stop() { this.running = false; }

  pause() { this.stop(); }
  resume() { this.start(); }
}
